// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","input":"Checkbox_input__KAVVD","label":"Checkbox_label__O-SB1"};